
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.63 6.77L13 4.54a3.09 3.09 0 00-3-2V1H6v1.5a3.09 3.09 0 00-3 2l-.63 2.27A2.28 2.28 0 001 8.87V13a1 1 0 002 0v-1h10v1a1 1 0 002 0V8.87a2.29 2.29 0 00-1.37-2.1zM3.57 9.69A.67.67 0 013 10a.68.68 0 010-1.33.67.67 0 01.57.33.64.64 0 010 .69zm6.93.3h-5a.5.5 0 01-.5-.5.5.5 0 01.5-.49h5a.51.51 0 01.5.5.5.5 0 01-.5.5zM12 6.68h-.1A24.51 24.51 0 008 6.49a24.51 24.51 0 00-3.9.2.26.26 0 01-.3-.2.49.49 0 010-.12l.43-1.5a1.85 1.85 0 011.86-1.13h3.82a1.85 1.85 0 011.85 1.13l.43 1.5a.25.25 0 01-.19.31zm1.55 3A.67.67 0 0113 10a.68.68 0 010-1.36.67.67 0 01.59.34.64.64 0 01-.02.71z"}})])
          )
        }
      }
    